import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { SurveyOptions } from '@lyearn-team/frontend-components';
import OpinionTypeData from '../../../../helper/OpinionTypes';

class SurveyOpinionResponse extends Component {
  static contextTypes = {
    checkForSubmit: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.textRefCode = `${this.props.questionId}_${this.props.cardId}`;
  }

  state = {
    submitButton: !this.props.response || this.props.response === '' ? 'hidden' : 'edit',
    textBoxValue: this.props.response,
    responseToBeSubmitted: null,
    optionIndex:
      this.props.questionObj.answer && this.props.questionObj.answer.length
        ? this.props.questionObj.answer[0].response === ''
          ? -1
          : parseInt(this.props.questionObj.answer[0].response, 10)
        : -1
  };

  onSelectionChange = optionIndex => {
    // console.log('callback ', optionIndex);
    if (this.state.optionIndex === optionIndex) {
      this.state.optionIndex = -1;
    } else {
      this.state.optionIndex = optionIndex;
    }
    this.setState({});
    this.props.saveOneResponse(this.getResponse());
  };

  getResponse = () => {
    const enteredResponse = this.state.optionIndex === -1 ? '' : this.state.optionIndex.toString();
    return {
      questionObj: this.props.questionObj,
      emptySubmittedResponse: this.emptySubmittedResponse,
      responseData: {
        questionId: this.props.questionId,
        response: enteredResponse,
        answerEvaluation: 'NA',
        responseType: 'OPINION_SCALE',
        deletingResponse: this.props.deletingResponse,
        isOptional: !this.props.questionObj.contributeToCompleteStatus
      }
    };
  };

  emptySubmittedResponse = () => {
    if (window.textCardContent[this.textRefCode]) {
      window.textCardContent[this.textRefCode].data = null;
    }
    this.setState({ textBoxValue: null });
  };

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.cardId !== nextProps.cardId) {
      this.state.responseToBeSubmitted = null;
      this.textRefCode = `${nextProps.questionId}_${nextProps.cardId}`;
      this.state.submitButton =
        !nextProps.response || nextProps.response === '' ? 'hidden' : 'edit';
      this.state.optionIndex =
        nextProps.questionObj.answer[0].response === ''
          ? -1
          : parseInt(nextProps.questionObj.answer[0].response, 10);
    }

    // console.log('test response:: ', this.props.response, nextProps.response);

    if (
      (!nextProps.isResponseEntered && nextProps.responseEditedFlag) ||
      (this.props.response !== undefined &&
        this.props.response !== nextProps.response &&
        nextProps.response === '')
    ) {
      this.state.textBoxValue = nextProps.response;
      this.state.optionIndex =
        nextProps.questionObj.answer[0].response === ''
          ? -1
          : parseInt(nextProps.questionObj.answer[0].response, 10);
      // this.setState({ textBoxValue: nextProps.response || '' });
    }
  }

  render() {
    return (
      <div>
        <SurveyOptions
          options={OpinionTypeData[this.props.questionObj.opinionType.toUpperCase()]}
          callBack={this.onSelectionChange}
          selectedOption={this.state.optionIndex}
          isDisabled={this.props.actualSubmit}
        />
      </div>
    );
  }
}

module.exports = SurveyOpinionResponse;
